import React from 'react'

import { StyledBase } from './style'

const Button = ({ btnStyle = 'standard', children, ...props }) =>
  <StyledBase btnStyle={btnStyle} {...props}>{children}</StyledBase>

export default Button
